<div class="hpanel gs-widget-cardmargin-bottom-5" *ngIf="showUI && viewType=='MIN'">
  <div class="panel-heading hbuilt wig-c">
    {{ headerTitle }}
    <span class="refresh-icon-693" title="Refresh" (click)="refreshConnections()">
      <ng-icon name="tablerRefresh"></ng-icon>
    </span>
  </div>
  <!-- Business load / refresh in flight: skeleton shaped like the widget
       (avatar row + Invite bar); styled in business.component.scss -->
  <div *ngIf="loadAPIcall" class="panel-body gs-widget-body gs-inv-skel" aria-busy="true" aria-label="Loading connections">
    <div class="gs-inv-skel-avs">
      <span class="gs-inv-skel-sk gs-inv-skel-av" *ngFor="let n of [1, 2, 3, 4, 5, 6].slice(0, avatarLimit)"></span>
    </div>
    <span class="gs-inv-skel-sk gs-inv-skel-btn"></span>
  </div>
  <div *ngIf="!loadAPIcall" class="panel-body gs-widget-body">

    <!-- Business page + exactly one connection: wireframe single-row
         (avatar + name/title + small inline Invite). Other pages / counts use
         the avatar-row + full-button layout below. -->
    <div class="gs-single-row" *ngIf="inputData == 'BUSINESS' && userConnecction.length === 1">
      <a class="gs-single-av" *ngIf="userConnecction[0].photo" title="{{ userConnecction[0].firstName }} {{ userConnecction[0].lastName }}" (click)="route(userConnecction[0])">
        <img [src]="imgUrl + userConnecction[0].photo">
      </a>
      <div *ngIf="!userConnecction[0].photo" class="gs-single-av" title="{{ userConnecction[0].firstName }} {{ userConnecction[0].lastName }}" [style.background-color]="getColorName(userConnecction[0].firstName, userConnecction[0].lastName)" (click)="route(userConnecction[0])">
        <div class="circle-text" [style.color]="getTextColor(userConnecction[0].firstName, userConnecction[0].lastName)">{{ getInitialName(userConnecction[0].firstName, userConnecction[0].lastName) }}</div>
      </div>
      <div class="gs-single-info">
        <div class="gs-single-name" title="{{ userConnecction[0].firstName }} {{ userConnecction[0].lastName }}">{{ userConnecction[0].firstName }} {{ userConnecction[0].lastName }}</div>
        <div class="gs-single-role" title="{{ userConnecction[0].title }}">{{ userConnecction[0].title }}</div>
      </div>
      <button type="button" class="gs-invite-sm" (click)="inviteSingle(userConnecction[0])">Invite</button>
    </div>

    <ng-container *ngIf="!(inputData == 'BUSINESS' && userConnecction.length === 1)">
    <div class="row">
      <div class="col-lg-12">
        <div class="community-admin d-flex justify-content-center"
          [style.justify-content]="userConnecction?.length > 0 ? 'start' : 'center'">
          <ng-container *ngIf="userConnecction.length > 0; else noConnectionsYet">
            <div class="photo-container" *ngFor="let item of userConnecction.slice(0, avatarLimit); let i = index;">
              <a class="pd-3" *ngIf="item.photo" title="{{ item.firstName }} {{ item.lastName }}"  (click)="route(item)">
                <img class="user-photo" [src]="imgUrl + item.photo">
              </a>
              <div *ngIf="!item.photo" class="circles" title="{{ item.firstName }} {{ item.lastName }}" [style.background-color]="getColorName(item.firstName, item.lastName)" (click)="route(item)">
                <div class="circle-text" [style.color]="getTextColor(item.firstName, item.lastName)" style="font-size: var(--gs-wg-initials-size, 17px) !important; font-weight: 550;">{{ getInitialName(item.firstName, item.lastName) }}</div>
              </div>
            </div>
            <!-- Wireframe "+N": suggestions beyond the 5/6 shown (avatarLimit) (business data.total) -->
            <div class="photo-container" *ngIf="inviteMore > 0">
              <button type="button" class="gs-inv-more" [title]="inviteMore + ' more'" (click)="openModal(template)">+{{ inviteMore }}</button>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 col-lg-12" *ngIf="userConnecction.length>0">
        <button type="button" class="gs-invite-full" (click)="openModal(template)">Invite</button>
      </div>
    </div>
    </ng-container>
    <div class="text-center" style="display: grid;" *ngIf="pageName=='BUSINESS_LIST' && inputData == 'HOME'">
      Visit your Business Pages and invite your Connections to your Business.
    </div>
    <div class="text-center" style="display: grid;" *ngIf="pageName=='COMMUNITY_LIST' && inputData == 'HOME'">
      Visit your Community Pages and invite your Connections to your Community.
    </div>
  </div>
</div>

<ng-template #noConnectionsYet>
  <div class="gs-empty" *ngIf="inputData=='BUSINESS' || inputData=='COMMUNITY'">
    <span class="gs-empty-icon"><ng-icon name="tablerUsers"></ng-icon></span>
    <div class="gs-empty-title">No connections yet</div>
    <div class="gs-empty-sub">Reach out to grow your network.</div>
  </div>
</ng-template>

<ng-template #template>
  <div class="common-header-flex">
    <div>{{headerTitle}}</div>
    <button>
      <span (click)="closeModal()" class="common-close">&times;</span>
    </button>
  </div>
  <!-- Search + Select All on a single row: search grows to fill, Select All
       pinned to the flex end. `.invite-search-wrap` keeps position:relative
       so the `.pos-rel-28` magnifier stays anchored to the input. -->
  <div class="col-sm-12 invite-action-row">
    <div class="invite-search-wrap">
      <input type="text" class="form-control pd-lt-30" (keyup)="onSearch($event)" name="searchName"
      id="xcxcv" aria-describedby="helpId" placeholder="Search Connections" [(ngModel)]="searchName" />
      <ng-icon name="tablerSearch" class="pos-rel-28" style="left: 11px !important;"></ng-icon>
    </div>
    <div class="invite-select-all" *ngIf="filteredConnectionList.length>1">
      <!-- && !beingTyped -->
      <label for="">Select All</label>
      <div class="custom-checkbox em" style="margin-top: -18px !important;">
        <label class="checkbox-label font-bold" style="text-align: center">
          <input type="checkbox" [(ngModel)]="theChecker" (change)="checkAll($event)" />
          <span class="checkmark"></span>
        </label>
      </div>
    </div>
  </div>
  <div class="panel" #scrollableDiv infiniteScroll [infiniteScrollDistance]="1"
  [infiniteScrollUpDistance]="2" [scrollWindow]="false" (scrolled)="infiniteScrollTriggered()">
 
    <div *ngFor="let data of filteredConnectionList | paginate: config;  let i = index ">
      <div class="oi">
        <div class="row poi">
          <div class="col-sm-1">
            <img *ngIf="data?.photo" class="circles" [src]="imgUrl+data.photo"/>
            <div *ngIf="!data?.photo">
              <div class="circles" [style.background-color]="getColorName(data.firstName,data.lastName)">
                <div class="circle-text " [style.color]="getTextColor(data?.firstName, data?.lastName)" style="font-weight: 550;font-size: 17px;">{{ getInitialName(data.firstName,data.lastName) }}</div>
              </div>
            </div>
          </div>
          <div class="col-sm-8 lr-lt-10">
            <h6 class="fw-bold" title="{{ data.firstName }} {{ data.lastName }}">
              {{ data.firstName }} {{ data.lastName }}
            </h6>
            <div class="overflow-hiden-" title="{{ data.title }}">
              {{ data.title }}
            </div>
          </div>
          <div class="col-sm-2 rm">
            <div class="custom-checkbox em">
              <label class="checkbox-label font-bold" style="text-align: center">
                <input type="checkbox" [(ngModel)]="data.checked"
                  (change)="onCheckboxChange(data, $event)" />
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
     <!-- Search returned no matches: mirror the team-members / community-members
          "no results" empty state (screen="SEARCH") instead of a blank panel.
          Gated on searchName only (not on a source-list length) because the
          BUSINESS server-search path empties modalConnectionList on no-match,
          so a term-present check is the reliable "user is searching" signal. -->
     <div class="col-sm-12"
       *ngIf="filteredConnectionList.length === 0 && searchName?.length > 0">
       <app-nodata-found
         screen="SEARCH"
         [title]="['No results found']"
         [buttonShow]="false">
       </app-nodata-found>
     </div>
     <div>
      <div class="gs-end-of-list" *ngIf="stopScroll && filteredConnectionList.length > 0" style="margin-top: 1rem;text-align: center;">
        <div class="col-md-12 mg-bt-9">
                    <ng-icon name="tablerCircleCheck"></ng-icon>
        </div>
        <div class="col-md-12">
          <p class="biase">You've reached the bottom of the page</p>
        </div>
      </div>
     </div>
  </div>

  <div class="modal-footer">
    <div class="col-sm-6">
      <!-- Pagination controls if needed -->
    </div>
    <div class="col-sm-6">
      <div class="footerContainer" style="float: right">
        <div class="footerIteam1">
          <button class="btn btn-default mr-2" (click)="dismiss()">
            Cancel
          </button>
        </div>
        <div class="footerIteam2">
          <button class="btn primary-btn btn-close-gap" [disabled]="selectedEntities.length == 0||apicalled"
            (click)="inviteAll()">
            Send Invitation
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>